import { XStylesSettings } from '@shared/types/types';
import * as stylex from '@stylexjs/stylex';
import { TabProps } from '../model/types';
import { styles } from './styles';

const Tab = (props: TabProps) => {
  const {
    isActive = false,
    size = 'medium',
    changeFunction,
    settings,
    marker = false,
    title = 'Заголовок',
    messageCount,
    'data-testid': testId,
  } = props;

  return (
    <button
      data-testid={testId}
      onClick={changeFunction}
      {...stylex.props(styles.base(isActive), styles.title(isActive), styles[size], settings as XStylesSettings)}
    >
      {title} {marker && <div {...stylex.props(styles.messageCount)}>{messageCount}</div>}
    </button>
  );
};

export default Tab;
